import { render, staticRenderFns } from "./DocumentPageEditor.vue?vue&type=template&id=090fb726&scoped=true&"
import script from "./DocumentPageEditor.vue?vue&type=script&lang=ts&"
export * from "./DocumentPageEditor.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentPageEditor.vue?vue&type=style&index=0&id=090fb726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090fb726",
  null
  
)

export default component.exports